import React from "react";
import { Outlet } from "react-router-dom";
import HomeFooter from "@/pages/v2/sections/HomeFooter";
import RouteCanonical from "@/components/seo/RouteCanonical";
import "@/pages/v2/v2-styles.css";

const Layout = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="v2-root" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <RouteCanonical />
      <main style={{ flex: 1 }}>
        {children || <Outlet />}
      </main>
      <HomeFooter />
    </div>
  );
};

export default Layout;
